import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router';

import { Container, Header, Tabs } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import { SettingsHeaderActionsPortalContext } from './components/SettingsHeader.context';
import { headerActionsSlotStyle } from './SettingsLayout.css';

export const SettingsLayout = () => {
  const [headerActionsPortal, setHeaderActionsPortal] = useState<HTMLDivElement | null>(null);

  const { pathname } = useLocation();
  const { t } = useTranslation(['settings']);

  return (
    <SettingsHeaderActionsPortalContext value={headerActionsPortal}>
      <Header.Root>
        <Header.Content title={t('settings:header.title')} />

        <div className={headerActionsSlotStyle} ref={setHeaderActionsPortal} />

        <Header.Tabs>
          <Tabs.Root value={pathname.replace(/\/$/, '')}>
            <Tabs.List>
              <Tabs.TabLink icon="Person" replace to={routes.settingsProfile} value={routes.settingsProfile}>
                {t('settings:tabs.profile')}
              </Tabs.TabLink>

              <Tabs.TabLink icon="Mail" replace to={routes.settingsEmail} value={routes.settingsEmail}>
                {t('settings:tabs.email')}
              </Tabs.TabLink>

              <Tabs.TabLink icon="ReceiptLong" replace to={routes.settingsInvoice} value={routes.settingsInvoice}>
                {t('settings:tabs.invoice')}
              </Tabs.TabLink>

              <Tabs.TabLink icon="Company" replace to={routes.settingsCompany} value={routes.settingsCompany}>
                {t('settings:tabs.company')}
              </Tabs.TabLink>

              <Tabs.TabLink icon="Hub" replace to={routes.settingsIntegrations} value={routes.settingsIntegrations}>
                {t('settings:tabs.integrations')}
              </Tabs.TabLink>
            </Tabs.List>
          </Tabs.Root>
        </Header.Tabs>
      </Header.Root>

      <Container>
        <Outlet />
      </Container>
    </SettingsHeaderActionsPortalContext>
  );
};
